import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TvshopConstants} from '../../shared/tvshop-constants';
import {LocalApiService} from '../local-api/local-api.service';
import {map} from 'rxjs/operators';
import {Environment} from '../../shared/environment/environment';

@Injectable()
export class LanguageService {

  constructor(private router: ActivatedRoute,
              private translateService: TranslateService,
              private localApiService: LocalApiService) {
    this.translateService.setDefaultLang('nl');
  }

  public getLocaleParams(): Observable<string> {
    return this.router
      .queryParamMap.pipe(map(paramMap => paramMap.get('locale')));
  }

  public setLanguageFromParams(locale: string) {
    if (locale && TvshopConstants.LOCALE_ARRAY.find(lang => lang === locale)) {
      this.translateService.use(locale);
    }
  }

  public setLanguage() {
    this.getLocaleParams().subscribe(param => {
      if (param) {
        this.setLanguageFromParams(param);
      } else if (Environment.environmentConfig().environment !== 'local') {
        this.localApiService.getBoxLanguage().subscribe(data => {
            if (data) {
              this.translateService.use(data + '');
            }
          }
        );
      }
    });
  }

  public getCurrentLanguage(): string {
    if (this.translateService.currentLang) {
      return this.translateService.currentLang;
    }
    return this.translateService.defaultLang;
  }


}
